import {apiRegister} from '../../common/api'
import {NO_ERROR, ERR_REP} from '../../const'

// 1015	appsystem	/appsystem/finishversion/data/	获取最新的的通过的APP版本号

export const latestWZApp = apiRegister('latestWZApp', {
  protoId: 1015,
  path: '/appsystem/finishversion/data/',
  checkResult({info}) {
    if(!info || !info.version) {
      return ERR_REP
    }
    return NO_ERROR
  }
}).send
